import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={manga.coverImage}
          alt={`${manga.title} - ${manga.categoryLabel}腐漫`}
          title={`${manga.title} - ${manga.seoKeywords}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-background-50">
            {manga.categoryLabel}
          </span>
        </div>
        {manga.status === '已完结' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-foreground-800/80 text-background-50">
              已完结
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              {manga.rating}
            </span>
            <span className="opacity-70">{manga.views.toLocaleString()} 阅读</span>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-1">
          {manga.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{manga.author}</p>
        <p className="text-xs text-foreground-400 mt-1.5 line-clamp-2 leading-relaxed">{manga.description}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {manga.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 text-[10px] rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}